export { default } from './getCookie'
